(() => {
  const cleanups = new WeakMap();

  const init = (root = document) => {
    const groups = root.matches?.('[data-l-series-faq-group]') ? [root] : [...(root.querySelectorAll?.('[data-l-series-faq-group]') || [])];
    groups.forEach((group) => {
      if (cleanups.has(group)) return;
      const items = [...group.querySelectorAll('[data-l-series-faq-item]')];
      const animations = new Map();
      const desired = new Map();
      const listeners = [];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const parts = (details) => {
        const summary = details.querySelector(':scope > summary');
        const panel = summary?.getAttribute('aria-controls') ? document.getElementById(summary.getAttribute('aria-controls')) : null;
        return { summary, panel };
      };
      const clear = (panel) => ['height', 'overflow', 'opacity', 'transform'].forEach((name) => panel.style.removeProperty(name));
      const immediate = (details, open) => {
        animations.get(details)?.cancel();
        animations.delete(details);
        const { summary, panel } = parts(details);
        details.open = open;
        desired.set(details, open);
        summary?.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) clear(panel);
      };
      const animate = (details, open) => {
        const { summary, panel } = parts(details);
        if (!summary || !panel || reducedMotion.matches || typeof panel.animate !== 'function') return immediate(details, open);
        const wasOpen = details.open;
        const previous = animations.get(details);
        const startHeight = panel.getBoundingClientRect().height;
        const current = getComputedStyle(panel);
        const startOpacity = wasOpen ? current.opacity : '0';
        const startTransform = wasOpen && current.transform !== 'none' ? current.transform : (wasOpen ? 'translateY(0)' : 'translateY(3px)');
        previous?.cancel();
        desired.set(details, open);
        summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) details.open = true;
        panel.style.height = `${startHeight}px`;
        panel.style.overflow = 'hidden';
        panel.style.opacity = startOpacity;
        panel.style.transform = startTransform;
        const endHeight = open ? panel.scrollHeight : 0;
        const animation = panel.animate([
          { height: `${startHeight}px`, opacity: startOpacity, transform: startTransform },
          { height: `${endHeight}px`, opacity: open ? 1 : 0, transform: open ? 'translateY(0)' : 'translateY(-3px)' }
        ], { duration: 360, easing: 'ease-in-out', fill: 'forwards' });
        animations.set(details, animation);
        animation.finished.then(() => {
          if (animations.get(details) !== animation) return;
          animations.delete(details);
          if (!open) details.open = false;
          animation.cancel();
          clear(panel);
        }).catch(() => {});
      };
      items.forEach((details) => {
        const { summary } = parts(details);
        if (!summary) return;
        desired.set(details, details.open);
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        const click = (event) => {
          event.preventDefault();
          const open = !(desired.get(details) ?? details.open);
          if (open) items.forEach((item) => { if (item !== details && (desired.get(item) || item.open)) animate(item, false); });
          animate(details, open);
        };
        summary.addEventListener('click', click);
        listeners.push(() => summary.removeEventListener('click', click));
      });
      cleanups.set(group, () => {
        listeners.forEach((remove) => remove());
        animations.forEach((animation, details) => { animation.cancel(); const { panel } = parts(details); if (panel) clear(panel); });
        animations.clear();
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const group = event.target.querySelector?.('[data-l-series-faq-group]');
    if (group) cleanups.get(group)?.();
  });
})();
